module.exports = __webpack_public_path__ + "img/add_activity.e081fbc7.png";